import React from 'react';
import {
  expandSvg,
  Tool,
  svgToIcon,
  type ToolArgsWithController,
  ToolButtonComponent,
  tools,
} from '@aha-app/aha-editor-v2';
import { whiteboardControllerForEditor } from '../EmbeddedWhiteboardControllersPluginFactory';

class ToolEditWhiteboard extends Tool {
  static toolName = 'Edit';

  static available(toolArgs: ToolArgsWithController): boolean {
    return toolArgs.controller.ahaEditor.hasPlugin(
      'EmbeddedWhiteboardControllersPlugin'
    );
  }

  static renderToolbarButtonIcon(): JSX.Element {
    return svgToIcon(expandSvg);
  }

  static renderToolbarComponent(toolArgs: ToolArgsWithController) {
    const { controller, element } = toolArgs;
    const whiteboardController = whiteboardControllerForEditor(
      controller.ahaEditor,
      element
    );
    const href = whiteboardController?.getDisplayModeUrl('fullscreen');

    return (
      <ToolButtonComponent
        tool={this}
        href={href}
        onMouseDown={event => {
          if (event.metaKey && href) {
            window.open(href, '_blank');
          } else {
            if (this.isEnabled(toolArgs)) {
              tools.fireToolAction(this, event, toolArgs);
            } else {
              // Prevent blurring the editor.
              event.preventDefault();
            }
          }
        }}
        {...toolArgs}
      />
    );
  }

  static action({ controller, element }: ToolArgsWithController): void {
    const whiteboardController = whiteboardControllerForEditor(
      controller.ahaEditor,
      element
    );

    if (whiteboardController) {
      whiteboardController.router.navigate(
        whiteboardController.getDisplayModeUrl('fullscreen')
      );
    }
  }
}

export default ToolEditWhiteboard;
